import * as i0 from '@angular/core';
import { EventEmitter, NgZone, ElementRef, Component, Inject, NgModule } from '@angular/core';
import Moveable__default, { METHODS, EVENTS, PROPERTIES } from 'moveable';
export * from 'moveable';
import { __decorate, __metadata } from 'tslib';
import { withMethods } from 'framework-utils';
let NgxMoveableInterface = /*#__PURE__*/(() => {
  class NgxMoveableInterface {}
  __decorate([withMethods(METHODS, {
    dragStart: 'ngDragStart'
  }), __metadata("design:type", Moveable__default)], NgxMoveableInterface.prototype, "moveable", void 0);

  // auto
  // eslint-disable-next-line max-len
  return NgxMoveableInterface;
})();
const ANGULAR_MOVEABLE_INPUTS = ["target", "dragTargetSelf", "dragTarget", "dragContainer", "container", "warpSelf", "rootContainer", "useResizeObserver", "useMutationObserver", "zoom", "dragFocusedInput", "transformOrigin", "ables", "className", "pinchThreshold", "pinchOutside", "triggerAblesSimultaneously", "checkInput", "cspNonce", "translateZ", "hideDefaultLines", "props", "flushSync", "stopPropagation", "preventClickEventOnDrag", "preventClickDefault", "viewContainer", "persistData", "useAccuratePosition", "firstRenderState", "linePadding", "controlPadding", "preventDefault", "preventRightClick", "preventWheelClick", "requestStyles", "snappable", "snapContainer", "snapDirections", "elementSnapDirections", "snapGap", "snapGridWidth", "snapGridHeight", "isDisplaySnapDigit", "isDisplayInnerSnapDigit", "isDisplayGridGuidelines", "snapDigit", "snapThreshold", "snapRenderThreshold", "snapGridAll", "snapRotationThreshold", "snapRotationDegrees", "snapHorizontalThreshold", "snapVerticalThreshold", "horizontalGuidelines", "verticalGuidelines", "elementGuidelines", "bounds", "innerBounds", "snapDistFormat", "maxSnapElementGuidelineDistance", "maxSnapElementGapDistance", "pinchable", "draggable", "throttleDrag", "throttleDragRotate", "hideThrottleDragRotateLine", "startDragRotate", "edgeDraggable", "resizable", "throttleResize", "renderDirections", "displayAroundControls", "keepRatio", "resizeFormat", "keepRatioFinally", "edge", "checkResizableError", "scalable", "throttleScale", "warpable", "rotatable", "rotationPosition", "throttleRotate", "rotationTarget", "rotateAroundControls", "resolveAblesWithRotatable", "scrollable", "scrollContainer", "scrollThreshold", "scrollThrottleTime", "getScrollPosition", "scrollOptions", "padding", "origin", "svgOrigin", "originDraggable", "originRelative", "clippable", "defaultClipPath", "customClipPath", "clipRelative", "clipArea", "dragWithClip", "clipTargetBounds", "clipVerticalGuidelines", "clipHorizontalGuidelines", "clipSnapThreshold", "roundable", "roundRelative", "minRoundControls", "maxRoundControls", "roundClickable", "roundPadding", "isDisplayShadowRoundControls", "defaultGroupRotate", "useDefaultGroupRotate", "defaultGroupOrigin", "groupable", "groupableProps", "targetGroups", "hideChildMoveableDefaultLines", "individualGroupable", "individualGroupableProps", "clickable", "dragArea", "passDragArea"];
const ANGULAR_MOVEABLE_OUTPUTS = ["beforeRenderStart", "beforeRender", "beforeRenderEnd", "beforeRenderGroupStart", "beforeRenderGroup", "beforeRenderGroupEnd", "changeTargets", "snap", "bound", "pinchStart", "pinch", "pinchEnd", "pinchGroupStart", "pinchGroup", "pinchGroupEnd", "dragStart", "drag", "dragEnd", "dragGroupStart", "dragGroup", "dragGroupEnd", "resizeStart", "beforeResize", "resize", "resizeEnd", "resizeGroupStart", "beforeResizeGroup", "resizeGroup", "resizeGroupEnd", "scaleStart", "beforeScale", "scale", "scaleEnd", "scaleGroupStart", "beforeScaleGroup", "scaleGroup", "scaleGroupEnd", "warpStart", "warp", "warpEnd", "rotateStart", "beforeRotate", "rotate", "rotateEnd", "rotateGroupStart", "beforeRotateGroup", "rotateGroup", "rotateGroupEnd", "scroll", "scrollGroup", "dragOriginStart", "dragOrigin", "dragOriginEnd", "clipStart", "clip", "clipEnd", "roundStart", "round", "roundEnd", "roundGroupStart", "roundGroup", "roundGroupEnd", "click", "clickGroup", "renderStart", "render", "renderEnd", "renderGroupStart", "renderGroup", "renderGroupEnd"];
let NgxMoveableComponent = /*#__PURE__*/(() => {
  class NgxMoveableComponent extends NgxMoveableInterface {
    constructor(_ngZone, _elementRef) {
      super();
      this._ngZone = _ngZone;
      this._elementRef = _elementRef;
      EVENTS.forEach(name => {
        // @ts-expect-error
        this[name] = new EventEmitter();
      });
    }
    ngOnInit() {
      const options = {};
      const events = {};
      PROPERTIES.forEach(name => {
        // @ts-expect-error
        options[name] = this[name];
      });
      EVENTS.forEach(name => {
        events[name] = event => {
          // @ts-expect-error
          const emitter = this[name];
          if (emitter && (emitter.observed || emitter.observers.length > 0)) {
            this._ngZone.run(() => emitter.emit(event));
          }
        };
      });
      const container = this._elementRef.nativeElement;
      this.moveable = this._ngZone.runOutsideAngular(() => new Moveable__default(container, {
        ...options,
        warpSelf: true
      }));
      this.moveable.on(events);
    }
    ngOnChanges(changes) {
      const moveable = this.moveable;
      if (!moveable) {
        return;
      }
      for (const name in changes) {
        const {
          previousValue,
          currentValue
        } = changes[name];
        if (previousValue === currentValue) {
          continue;
        }
        // @ts-expect-error
        moveable[name] = currentValue;
      }
    }
    ngOnDestroy() {
      this.moveable.destroy();
    }
  }
  NgxMoveableComponent.ɵfac = function NgxMoveableComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxMoveableComponent)(i0.ɵɵdirectiveInject(NgZone), i0.ɵɵdirectiveInject(ElementRef));
  };
  NgxMoveableComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxMoveableComponent,
    selectors: [["ngx-moveable"]],
    inputs: {
      target: "target",
      dragTargetSelf: "dragTargetSelf",
      dragTarget: "dragTarget",
      dragContainer: "dragContainer",
      container: "container",
      warpSelf: "warpSelf",
      rootContainer: "rootContainer",
      useResizeObserver: "useResizeObserver",
      useMutationObserver: "useMutationObserver",
      zoom: "zoom",
      dragFocusedInput: "dragFocusedInput",
      transformOrigin: "transformOrigin",
      ables: "ables",
      className: "className",
      pinchThreshold: "pinchThreshold",
      pinchOutside: "pinchOutside",
      triggerAblesSimultaneously: "triggerAblesSimultaneously",
      checkInput: "checkInput",
      cspNonce: "cspNonce",
      translateZ: "translateZ",
      hideDefaultLines: "hideDefaultLines",
      props: "props",
      flushSync: "flushSync",
      stopPropagation: "stopPropagation",
      preventClickEventOnDrag: "preventClickEventOnDrag",
      preventClickDefault: "preventClickDefault",
      viewContainer: "viewContainer",
      persistData: "persistData",
      useAccuratePosition: "useAccuratePosition",
      firstRenderState: "firstRenderState",
      linePadding: "linePadding",
      controlPadding: "controlPadding",
      preventDefault: "preventDefault",
      preventRightClick: "preventRightClick",
      preventWheelClick: "preventWheelClick",
      requestStyles: "requestStyles",
      snappable: "snappable",
      snapContainer: "snapContainer",
      snapDirections: "snapDirections",
      elementSnapDirections: "elementSnapDirections",
      snapGap: "snapGap",
      snapGridWidth: "snapGridWidth",
      snapGridHeight: "snapGridHeight",
      isDisplaySnapDigit: "isDisplaySnapDigit",
      isDisplayInnerSnapDigit: "isDisplayInnerSnapDigit",
      isDisplayGridGuidelines: "isDisplayGridGuidelines",
      snapDigit: "snapDigit",
      snapThreshold: "snapThreshold",
      snapRenderThreshold: "snapRenderThreshold",
      snapGridAll: "snapGridAll",
      snapRotationThreshold: "snapRotationThreshold",
      snapRotationDegrees: "snapRotationDegrees",
      snapHorizontalThreshold: "snapHorizontalThreshold",
      snapVerticalThreshold: "snapVerticalThreshold",
      horizontalGuidelines: "horizontalGuidelines",
      verticalGuidelines: "verticalGuidelines",
      elementGuidelines: "elementGuidelines",
      bounds: "bounds",
      innerBounds: "innerBounds",
      snapDistFormat: "snapDistFormat",
      maxSnapElementGuidelineDistance: "maxSnapElementGuidelineDistance",
      maxSnapElementGapDistance: "maxSnapElementGapDistance",
      pinchable: "pinchable",
      draggable: "draggable",
      throttleDrag: "throttleDrag",
      throttleDragRotate: "throttleDragRotate",
      hideThrottleDragRotateLine: "hideThrottleDragRotateLine",
      startDragRotate: "startDragRotate",
      edgeDraggable: "edgeDraggable",
      resizable: "resizable",
      throttleResize: "throttleResize",
      renderDirections: "renderDirections",
      displayAroundControls: "displayAroundControls",
      keepRatio: "keepRatio",
      resizeFormat: "resizeFormat",
      keepRatioFinally: "keepRatioFinally",
      edge: "edge",
      checkResizableError: "checkResizableError",
      scalable: "scalable",
      throttleScale: "throttleScale",
      warpable: "warpable",
      rotatable: "rotatable",
      rotationPosition: "rotationPosition",
      throttleRotate: "throttleRotate",
      rotationTarget: "rotationTarget",
      rotateAroundControls: "rotateAroundControls",
      resolveAblesWithRotatable: "resolveAblesWithRotatable",
      scrollable: "scrollable",
      scrollContainer: "scrollContainer",
      scrollThreshold: "scrollThreshold",
      scrollThrottleTime: "scrollThrottleTime",
      getScrollPosition: "getScrollPosition",
      scrollOptions: "scrollOptions",
      padding: "padding",
      origin: "origin",
      svgOrigin: "svgOrigin",
      originDraggable: "originDraggable",
      originRelative: "originRelative",
      clippable: "clippable",
      defaultClipPath: "defaultClipPath",
      customClipPath: "customClipPath",
      clipRelative: "clipRelative",
      clipArea: "clipArea",
      dragWithClip: "dragWithClip",
      clipTargetBounds: "clipTargetBounds",
      clipVerticalGuidelines: "clipVerticalGuidelines",
      clipHorizontalGuidelines: "clipHorizontalGuidelines",
      clipSnapThreshold: "clipSnapThreshold",
      roundable: "roundable",
      roundRelative: "roundRelative",
      minRoundControls: "minRoundControls",
      maxRoundControls: "maxRoundControls",
      roundClickable: "roundClickable",
      roundPadding: "roundPadding",
      isDisplayShadowRoundControls: "isDisplayShadowRoundControls",
      defaultGroupRotate: "defaultGroupRotate",
      useDefaultGroupRotate: "useDefaultGroupRotate",
      defaultGroupOrigin: "defaultGroupOrigin",
      groupable: "groupable",
      groupableProps: "groupableProps",
      targetGroups: "targetGroups",
      hideChildMoveableDefaultLines: "hideChildMoveableDefaultLines",
      individualGroupable: "individualGroupable",
      individualGroupableProps: "individualGroupableProps",
      clickable: "clickable",
      dragArea: "dragArea",
      passDragArea: "passDragArea"
    },
    outputs: {
      beforeRenderStart: "beforeRenderStart",
      beforeRender: "beforeRender",
      beforeRenderEnd: "beforeRenderEnd",
      beforeRenderGroupStart: "beforeRenderGroupStart",
      beforeRenderGroup: "beforeRenderGroup",
      beforeRenderGroupEnd: "beforeRenderGroupEnd",
      changeTargets: "changeTargets",
      snap: "snap",
      bound: "bound",
      pinchStart: "pinchStart",
      pinch: "pinch",
      pinchEnd: "pinchEnd",
      pinchGroupStart: "pinchGroupStart",
      pinchGroup: "pinchGroup",
      pinchGroupEnd: "pinchGroupEnd",
      dragStart: "dragStart",
      drag: "drag",
      dragEnd: "dragEnd",
      dragGroupStart: "dragGroupStart",
      dragGroup: "dragGroup",
      dragGroupEnd: "dragGroupEnd",
      resizeStart: "resizeStart",
      beforeResize: "beforeResize",
      resize: "resize",
      resizeEnd: "resizeEnd",
      resizeGroupStart: "resizeGroupStart",
      beforeResizeGroup: "beforeResizeGroup",
      resizeGroup: "resizeGroup",
      resizeGroupEnd: "resizeGroupEnd",
      scaleStart: "scaleStart",
      beforeScale: "beforeScale",
      scale: "scale",
      scaleEnd: "scaleEnd",
      scaleGroupStart: "scaleGroupStart",
      beforeScaleGroup: "beforeScaleGroup",
      scaleGroup: "scaleGroup",
      scaleGroupEnd: "scaleGroupEnd",
      warpStart: "warpStart",
      warp: "warp",
      warpEnd: "warpEnd",
      rotateStart: "rotateStart",
      beforeRotate: "beforeRotate",
      rotate: "rotate",
      rotateEnd: "rotateEnd",
      rotateGroupStart: "rotateGroupStart",
      beforeRotateGroup: "beforeRotateGroup",
      rotateGroup: "rotateGroup",
      rotateGroupEnd: "rotateGroupEnd",
      scroll: "scroll",
      scrollGroup: "scrollGroup",
      dragOriginStart: "dragOriginStart",
      dragOrigin: "dragOrigin",
      dragOriginEnd: "dragOriginEnd",
      clipStart: "clipStart",
      clip: "clip",
      clipEnd: "clipEnd",
      roundStart: "roundStart",
      round: "round",
      roundEnd: "roundEnd",
      roundGroupStart: "roundGroupStart",
      roundGroup: "roundGroup",
      roundGroupEnd: "roundGroupEnd",
      click: "click",
      clickGroup: "clickGroup",
      renderStart: "renderStart",
      render: "render",
      renderEnd: "renderEnd",
      renderGroupStart: "renderGroupStart",
      renderGroup: "renderGroup",
      renderGroupEnd: "renderGroupEnd"
    },
    standalone: true,
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
    decls: 0,
    vars: 0,
    template: function NgxMoveableComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
  return NgxMoveableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxLegacyMoveableComponent = /*#__PURE__*/(() => {
  class NgxLegacyMoveableComponent extends NgxMoveableInterface {
    constructor(_ngZone, _elementRef) {
      super();
      this._ngZone = _ngZone;
      this._elementRef = _elementRef;
      EVENTS.forEach(name => {
        // @ts-expect-error
        this[name] = new EventEmitter();
      });
    }
    ngOnInit() {
      const options = {};
      const events = {};
      PROPERTIES.forEach(name => {
        // @ts-expect-error
        options[name] = this[name];
      });
      EVENTS.forEach(name => {
        events[name] = event => {
          // @ts-expect-error
          const emitter = this[name];
          if (emitter && (emitter.observed || emitter.observers.length > 0)) {
            this._ngZone.run(() => emitter.emit(event));
          }
        };
      });
      const container = this._elementRef.nativeElement;
      this.moveable = this._ngZone.runOutsideAngular(() => new Moveable__default(container, {
        ...options,
        warpSelf: true
      }));
      this.moveable.on(events);
    }
    ngOnChanges(changes) {
      const moveable = this.moveable;
      if (!moveable) {
        return;
      }
      for (const name in changes) {
        const {
          previousValue,
          currentValue
        } = changes[name];
        if (previousValue === currentValue) {
          continue;
        }
        // @ts-expect-error
        moveable[name] = currentValue;
      }
    }
    ngOnDestroy() {
      this.moveable.destroy();
    }
  }
  NgxLegacyMoveableComponent.ɵfac = function NgxLegacyMoveableComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxLegacyMoveableComponent)(i0.ɵɵdirectiveInject(NgZone), i0.ɵɵdirectiveInject(ElementRef));
  };
  NgxLegacyMoveableComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxLegacyMoveableComponent,
    selectors: [["ngx-moveable"]],
    inputs: {
      target: "target",
      dragTargetSelf: "dragTargetSelf",
      dragTarget: "dragTarget",
      dragContainer: "dragContainer",
      container: "container",
      warpSelf: "warpSelf",
      rootContainer: "rootContainer",
      useResizeObserver: "useResizeObserver",
      useMutationObserver: "useMutationObserver",
      zoom: "zoom",
      dragFocusedInput: "dragFocusedInput",
      transformOrigin: "transformOrigin",
      ables: "ables",
      className: "className",
      pinchThreshold: "pinchThreshold",
      pinchOutside: "pinchOutside",
      triggerAblesSimultaneously: "triggerAblesSimultaneously",
      checkInput: "checkInput",
      cspNonce: "cspNonce",
      translateZ: "translateZ",
      hideDefaultLines: "hideDefaultLines",
      props: "props",
      flushSync: "flushSync",
      stopPropagation: "stopPropagation",
      preventClickEventOnDrag: "preventClickEventOnDrag",
      preventClickDefault: "preventClickDefault",
      viewContainer: "viewContainer",
      persistData: "persistData",
      useAccuratePosition: "useAccuratePosition",
      firstRenderState: "firstRenderState",
      linePadding: "linePadding",
      controlPadding: "controlPadding",
      preventDefault: "preventDefault",
      preventRightClick: "preventRightClick",
      preventWheelClick: "preventWheelClick",
      requestStyles: "requestStyles",
      snappable: "snappable",
      snapContainer: "snapContainer",
      snapDirections: "snapDirections",
      elementSnapDirections: "elementSnapDirections",
      snapGap: "snapGap",
      snapGridWidth: "snapGridWidth",
      snapGridHeight: "snapGridHeight",
      isDisplaySnapDigit: "isDisplaySnapDigit",
      isDisplayInnerSnapDigit: "isDisplayInnerSnapDigit",
      isDisplayGridGuidelines: "isDisplayGridGuidelines",
      snapDigit: "snapDigit",
      snapThreshold: "snapThreshold",
      snapRenderThreshold: "snapRenderThreshold",
      snapGridAll: "snapGridAll",
      snapRotationThreshold: "snapRotationThreshold",
      snapRotationDegrees: "snapRotationDegrees",
      snapHorizontalThreshold: "snapHorizontalThreshold",
      snapVerticalThreshold: "snapVerticalThreshold",
      horizontalGuidelines: "horizontalGuidelines",
      verticalGuidelines: "verticalGuidelines",
      elementGuidelines: "elementGuidelines",
      bounds: "bounds",
      innerBounds: "innerBounds",
      snapDistFormat: "snapDistFormat",
      maxSnapElementGuidelineDistance: "maxSnapElementGuidelineDistance",
      maxSnapElementGapDistance: "maxSnapElementGapDistance",
      pinchable: "pinchable",
      draggable: "draggable",
      throttleDrag: "throttleDrag",
      throttleDragRotate: "throttleDragRotate",
      hideThrottleDragRotateLine: "hideThrottleDragRotateLine",
      startDragRotate: "startDragRotate",
      edgeDraggable: "edgeDraggable",
      resizable: "resizable",
      throttleResize: "throttleResize",
      renderDirections: "renderDirections",
      displayAroundControls: "displayAroundControls",
      keepRatio: "keepRatio",
      resizeFormat: "resizeFormat",
      keepRatioFinally: "keepRatioFinally",
      edge: "edge",
      checkResizableError: "checkResizableError",
      scalable: "scalable",
      throttleScale: "throttleScale",
      warpable: "warpable",
      rotatable: "rotatable",
      rotationPosition: "rotationPosition",
      throttleRotate: "throttleRotate",
      rotationTarget: "rotationTarget",
      rotateAroundControls: "rotateAroundControls",
      resolveAblesWithRotatable: "resolveAblesWithRotatable",
      scrollable: "scrollable",
      scrollContainer: "scrollContainer",
      scrollThreshold: "scrollThreshold",
      scrollThrottleTime: "scrollThrottleTime",
      getScrollPosition: "getScrollPosition",
      scrollOptions: "scrollOptions",
      padding: "padding",
      origin: "origin",
      svgOrigin: "svgOrigin",
      originDraggable: "originDraggable",
      originRelative: "originRelative",
      clippable: "clippable",
      defaultClipPath: "defaultClipPath",
      customClipPath: "customClipPath",
      clipRelative: "clipRelative",
      clipArea: "clipArea",
      dragWithClip: "dragWithClip",
      clipTargetBounds: "clipTargetBounds",
      clipVerticalGuidelines: "clipVerticalGuidelines",
      clipHorizontalGuidelines: "clipHorizontalGuidelines",
      clipSnapThreshold: "clipSnapThreshold",
      roundable: "roundable",
      roundRelative: "roundRelative",
      minRoundControls: "minRoundControls",
      maxRoundControls: "maxRoundControls",
      roundClickable: "roundClickable",
      roundPadding: "roundPadding",
      isDisplayShadowRoundControls: "isDisplayShadowRoundControls",
      defaultGroupRotate: "defaultGroupRotate",
      useDefaultGroupRotate: "useDefaultGroupRotate",
      defaultGroupOrigin: "defaultGroupOrigin",
      groupable: "groupable",
      groupableProps: "groupableProps",
      targetGroups: "targetGroups",
      hideChildMoveableDefaultLines: "hideChildMoveableDefaultLines",
      individualGroupable: "individualGroupable",
      individualGroupableProps: "individualGroupableProps",
      clickable: "clickable",
      dragArea: "dragArea",
      passDragArea: "passDragArea"
    },
    outputs: {
      beforeRenderStart: "beforeRenderStart",
      beforeRender: "beforeRender",
      beforeRenderEnd: "beforeRenderEnd",
      beforeRenderGroupStart: "beforeRenderGroupStart",
      beforeRenderGroup: "beforeRenderGroup",
      beforeRenderGroupEnd: "beforeRenderGroupEnd",
      changeTargets: "changeTargets",
      snap: "snap",
      bound: "bound",
      pinchStart: "pinchStart",
      pinch: "pinch",
      pinchEnd: "pinchEnd",
      pinchGroupStart: "pinchGroupStart",
      pinchGroup: "pinchGroup",
      pinchGroupEnd: "pinchGroupEnd",
      dragStart: "dragStart",
      drag: "drag",
      dragEnd: "dragEnd",
      dragGroupStart: "dragGroupStart",
      dragGroup: "dragGroup",
      dragGroupEnd: "dragGroupEnd",
      resizeStart: "resizeStart",
      beforeResize: "beforeResize",
      resize: "resize",
      resizeEnd: "resizeEnd",
      resizeGroupStart: "resizeGroupStart",
      beforeResizeGroup: "beforeResizeGroup",
      resizeGroup: "resizeGroup",
      resizeGroupEnd: "resizeGroupEnd",
      scaleStart: "scaleStart",
      beforeScale: "beforeScale",
      scale: "scale",
      scaleEnd: "scaleEnd",
      scaleGroupStart: "scaleGroupStart",
      beforeScaleGroup: "beforeScaleGroup",
      scaleGroup: "scaleGroup",
      scaleGroupEnd: "scaleGroupEnd",
      warpStart: "warpStart",
      warp: "warp",
      warpEnd: "warpEnd",
      rotateStart: "rotateStart",
      beforeRotate: "beforeRotate",
      rotate: "rotate",
      rotateEnd: "rotateEnd",
      rotateGroupStart: "rotateGroupStart",
      beforeRotateGroup: "beforeRotateGroup",
      rotateGroup: "rotateGroup",
      rotateGroupEnd: "rotateGroupEnd",
      scroll: "scroll",
      scrollGroup: "scrollGroup",
      dragOriginStart: "dragOriginStart",
      dragOrigin: "dragOrigin",
      dragOriginEnd: "dragOriginEnd",
      clipStart: "clipStart",
      clip: "clip",
      clipEnd: "clipEnd",
      roundStart: "roundStart",
      round: "round",
      roundEnd: "roundEnd",
      roundGroupStart: "roundGroupStart",
      roundGroup: "roundGroup",
      roundGroupEnd: "roundGroupEnd",
      click: "click",
      clickGroup: "clickGroup",
      renderStart: "renderStart",
      render: "render",
      renderEnd: "renderEnd",
      renderGroupStart: "renderGroupStart",
      renderGroup: "renderGroup",
      renderGroupEnd: "renderGroupEnd"
    },
    features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
    decls: 0,
    vars: 0,
    template: function NgxLegacyMoveableComponent_Template(rf, ctx) {},
    encapsulation: 2
  });
  return NgxLegacyMoveableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxMoveableModule = /*#__PURE__*/(() => {
  class NgxMoveableModule {}
  NgxMoveableModule.ɵfac = function NgxMoveableModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxMoveableModule)();
  };
  NgxMoveableModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxMoveableModule
  });
  NgxMoveableModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return NgxMoveableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-moveable
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxLegacyMoveableComponent, NgxMoveableComponent, NgxMoveableModule };

